import { Component, inject } from '@angular/core';
import { ComponentView } from 'src/modules/app-template/models/component-view.model';
import { Strings } from "src/modules/utils/shared/strings";
import { AdminPageDefinition } from '../../models/admin-page-definition.model';
import { FeatureModuleService } from '../../services/feature-module.service';
import { Arrays } from 'src/modules/utils/shared/arrays';
import { EditGlobalEMailTemplatesComponent } from '../edit-global-email-templates.component/edit-global-email-templates.component';

@Component({
    selector: 'app-general-admin',
    templateUrl: './general-admin.component.html',
    styleUrl: './general-admin.component.scss',
    standalone: false
})
export class GeneralAdminComponent extends ComponentView {

    featureModuleService = inject(FeatureModuleService);

    pages: AdminPageDefinition[] = [];
    categories: string[] = [];

    async initParams(): Promise<boolean> {
        this.fullScreenComponent = false;
        this.pages = [];
        if (this.app.mainConfig.useAdminUsers) {
            this.pages.push(new AdminPageDefinition("Benutzer", "Benutzer", "fas fa-users", ["/base2", "admin", "editGeneralUsers"]));
        }
        if (this.app.mainConfig.useAdminUserGroups) {
            this.pages.push(new AdminPageDefinition("Benutzergruppen", "Benutzer", "fas fa-user-group", ["/base2", "admin", "editGeneralUserGroups"]));
        }
        if (this.app.mainConfig.useGlobalEMailTemplates) {
            this.pages.push(EditGlobalEMailTemplatesComponent.staticDefinition.getAdminPage());
        }
        for (let def of this.app.mainConfig.genericObjectDefinitions ?? []) {
            this.pages.push(new AdminPageDefinition(def.title, "", Strings.def(def.icon, "fas fa-cog"), def.singleton ? 
                ["/base2", "admin", "generic-edit", def.scope, def.id, "0"] :
                ["/base2", "admin", "generic-list", def.scope, def.id]));
        }

        this.pages = [...this.pages, ...this.featureModuleService.getAdminPages()];
        this.categories = Arrays.getUnique(this.pages.map(p => p.category).filter(c => c != null));

        this.app.updateNavigation(null, [
            { label: "Administration", routerLink: ["/base2", "admin"] }
        ]);

        return Promise.resolve(true);
    }
    
}